import { render } from "./FooterMain.vue?vue&type=template&id=77d72027&scoped=true"
import script from "./FooterMain.vue?vue&type=script&lang=js"
export * from "./FooterMain.vue?vue&type=script&lang=js"

import "./FooterMain.vue?vue&type=style&index=0&id=77d72027&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d72027"]])

export default __exports__